export const rollcallregistrationlistdata = [
  {
    id: 1,
    name: "John Doe",
    biometric: "BIO12345",
    mobile: "9876543210",
    designation: "Software Engineer",
    department: "IT",
    actions: "Edit, View",
    resign: "No",
  },
  {
    id: 2,
    name: "Jane Smith",
    biometric: "BIO12346",
    mobile: "9876543211",
    designation: "HR Manager",
    department: "HR",
    actions: "Edit, View",
    resign: "Yes",
  },
  {
    id: 3,
    name: "Amit Kumar",
    biometric: "BIO12347",
    mobile: "9876543212",
    designation: "Accountant",
    department: "Finance",
    actions: "Edit, View",
    resign: "No",
  },
  {
    id: 4,
    name: "Priya Sharma",
    biometric: "BIO12348",
    mobile: "9876543213",
    designation: "Marketing Executive",
    department: "Marketing",
    actions: "Edit, View",
    resign: "No",
  },
  {
    id: 5,
    name: "Robert Brown",
    biometric: "BIO12349",
    mobile: "9876543214",
    designation: "Product Manager",
    department: "Product",
    actions: "Edit, View",
    resign: "No",
  },
  {
    id: 6,
    name: "Maria Lopez",
    biometric: "BIO12350",
    mobile: "9876543215",
    designation: "UI/UX Designer",
    department: "Design",
    actions: "Edit, View",
    resign: "No",
  },
  {
    id: 7,
    name: "Sunil Gupta",
    biometric: "BIO12351",
    mobile: "9876543216",
    designation: "DevOps Engineer",
    department: "IT",
    actions: "Edit, View",
    resign: "Yes",
  },
  {
    id: 8,
    name: "Emily Clark",
    biometric: "BIO12352",
    mobile: "9876543217",
    designation: "Business Analyst",
    department: "Operations",
    actions: "Edit, View",
    resign: "No",
  },
  {
    id: 9,
    name: "Ravi Verma",
    biometric: "BIO12353",
    mobile: "9876543218",
    designation: "Legal Advisor",
    department: "Legal",
    actions: "Edit, View",
    resign: "No",
  },
  {
    id: 10,
    name: "Sophia Martinez",
    biometric: "BIO12354",
    mobile: "9876543219",
    designation: "Sales Manager",
    department: "Sales",
    actions: "Edit, View",
    resign: "No",
  },
  {
    id: 11,
    name: "Vikram Singh",
    biometric: "BIO12355",
    mobile: "9876543220",
    designation: "QA Engineer",
    department: "Quality",
    actions: "Edit, View",
    resign: "No",
  },
  {
    id: 12,
    name: "Lisa Kim",
    biometric: "BIO12356",
    mobile: "9876543221",
    designation: "Content Writer",
    department: "Content",
    actions: "Edit, View",
    resign: "Yes",
  },
];
